export default {
    black: '#000000',
    white: '#ffffff',
    nearlyBlack: '#313131',
    nearlyWhite: '#F4F4F4',
    error: '#DA291C',
    pwpBlack: '#050505',
    red: {
        base: '#DA291C',
        dark: '#C12317',
    },
    green: {
        lighter: '#cad94a',
        light: '#d3e002',
        base: '#cedc00',
        dark: '#c9d602',
        darkAlt: '#C4C90F',
        darker: '#C9CF0F',
        darkest: '#BFC40F',
        baseRgb: '206, 220, 0',
    },
    grey: {
        97: 'hsl(0, 0%, 97%);',
        96: 'hsl(0, 0%, 96%);',
        95: 'hsl(0, 0%, 95%);',
        90: 'hsl(0, 0%, 90%);',
        85: 'hsl(0, 0%, 85%);',
        80: 'hsl(0, 0%, 80%);',
        75: 'hsl(0, 0%, 75%);',
        70: 'hsl(0, 0%, 70%);',
        65: 'hsl(0, 0%, 65%);',
        60: 'hsl(0, 0%, 60%);',
        55: 'hsl(0, 0%, 55%);',
        50: 'hsl(0, 0%, 50%);',
        45: 'hsl(0, 0%, 45%);',
        40: 'hsl(0, 0%, 40%);',
        35: 'hsl(0, 0%, 35%);',
        30: 'hsl(0, 0%, 30%);',
        25: 'hsl(0, 0%, 25%);',
        20: 'hsl(0, 0%, 20%);',
        15: 'hsl(0, 0%, 15%);',
        10: 'hsl(0, 0%, 10%);',
        '05': 'hsl(0, 0%, 5%);',
        fieldBackground: '#F9F9F9',
        authRetailerBackground: '#191b1c',
        toolAccent: '#54585A',
        toolAccentDark: '#4c4f51',
        toolAccentDarker: '#3f4243',
        splitContentBg: '#25282A',
        softBlack: '#1c1c1c',
    },
    heritage: {
        blue: '#1E3B5D',
        yellow: '#FEB51C',
    },
    paypal: {
        payBlue: '#00457C',
        palBlue: '#0079C1',
        black: '#000',
        white: '#FFF',
    },
    trustpilot: {
        grey: '#dcdce5',
        bad: '#ea4b39',
        poor: '#ee8b48',
        average: '#f8cd52',
        great: '#8cc94a',
        excellent: '#54b181',
    },
    bs: (expand = false) => {
        if (expand === true) {
            return 'rgba(0, 0, 0, 0.16) 0 6px 12px';
        }
        return 'rgba(0, 0, 0, 0.16) 0 3px 6px';
    },
    factTags: {
        green: {
            web: '#cedc00',
            print: '#bfff0d',
        },
        grey: {
            web: '#57585a',
            print: '#333333',
        },
        maxPower: {
            web: '#121212',
            print: '#121212',
        },
    },
};
